/**
 * The error message to be logged when trying to access `getLocalizationContext` api while browser context does not exist.
 * @type {String}
 */
export const LOCALIZATION_CONTEXT_DOES_NOT_EXIST =
    'Browser localization context does not exist, please ensure the run time owner sets one on the window scope before using this API';
